import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const ProductPackagingCheckList: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    return (
        <InspectionChecklist 
            {...props}
            defaultHeader="Packaging Check"
            completionTranslationKey="packaging_check_complete"
        />
    );
};